import { useState } from 'react'
import { Alert } from 'reactstrap'
import { useSelector } from 'react-redux'
import { VehicleCertQuery } from '../../services/endpoints/service29'
import useCertList from './useCertList'
import DataGrid, { Column, Sorting } from 'devextreme-react/data-grid'
import { selectIsAdmin } from '../../redux/slices'
import { makeStatusRenderer, renderDate, renderUser } from './Service29Utils'
import PageSizeSelect from './PageSizeSelect'
import CertPager from './CertPager'

const BASE_QUERY: VehicleCertQuery = {
  status: ['revoked', 'expired'],
  showAll: true,
  sort: 'deletedAt',
  order: 'desc',
  max: 50,
  offset: 0
}

const renderStatus = makeStatusRenderer({
  revoked: { label: 'Revoked', color: 'danger' },
  expired: { label: 'Expired', color: 'secondary' }
})

const Service29HistoryTab = () => {
  const isAdmin = useSelector(selectIsAdmin)
  const [query, setQuery] = useState<VehicleCertQuery>(BASE_QUERY)
  const { certs, total, error } = useCertList(isAdmin, query)

  if (!isAdmin) return null

  return (
    <section className="cert-tab-section">
      {error && <Alert color="danger">{error}</Alert>}
      <menu className="cert-tab-toolbar">
        <li style={{ marginLeft: 'auto' }}>
          <PageSizeSelect
            value={query.max ?? 50}
            onChange={(max) =>
              setQuery((prev) => ({ ...prev, max, offset: 0 }))
            }
          />
        </li>
      </menu>
      <DataGrid
        dataSource={certs}
        keyExpr="id"
        showBorders={true}
        rowAlternationEnabled={true}
        columnAutoWidth={true}
        allowColumnResizing={true}
      >
        <Sorting mode="none" />
        <Column dataField="vehicle.displayName" caption="Vehicle" />
        <Column dataField="vehicle.vin" caption="VIN" />
        <Column dataField="device.serial" caption="Device" />
        <Column dataField="status" caption="Status" cellRender={renderStatus} />
        <Column
          dataField="requestedBy"
          caption="Requested By"
          cellRender={renderUser}
        />
        <Column
          dataField="revokedBy"
          caption="Revoked By"
          cellRender={renderUser}
        />
        <Column
          dataField="deletedAt"
          caption="Revoked/Expired At"
          cellRender={renderDate}
        />
      </DataGrid>
      <CertPager
        total={total}
        offset={query.offset ?? 0}
        max={query.max ?? 50}
        onPageChange={(offset) => setQuery((prev) => ({ ...prev, offset }))}
      />
    </section>
  )
}

export default Service29HistoryTab
